<template>
  <span>
    <span
      v-for="r in [{name: $t('library.library'), id: null}, ...route]"
      :key="r.id"
    >
      <v-chip
        @click="handleClick(r)"
        lg
      >
        {{r.name}}
      </v-chip>
      <v-icon>
        mdi-chevron-right
      </v-icon>
    </span>
  </span>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'

export default {
  computed: {
    ...mapGetters('folder', [
      'route'
    ])
  },
  methods: {
    ...mapMutations('folder', [
      'OPEN_FOLDER'
    ]),
    ...mapActions('folder', [
      'getFolders'
    ]),
    handleClick(r) {
      this.OPEN_FOLDER(r.id);
      this.getFolders(r.id);
      this.$router.replace({
        query: { id: r.id || 'root', type: 'folder' }
      })
    }
  }
}
</script>